/** Dependencies */
import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import booksMenu from '../../menu/Menu';
/** Services */
import { MissingReceiptsAdminProvider } from './services/Services';

/*******************************************************************************
 * csm.books.missingReceiptsAdmin
 *
 * The reusable "Missing Receipts Admin" grid + create-receipt dialog
 * now live in CSMCommonWeb (csm.common.missingReceiptsAdmin) so CSMAdmin's
 * Charge Detail "Fix Receipt" flow can reuse the exact same client-side UI
 * instead of CSMAdmin maintaining its own duplicate copy. See:
 *   CSMCommonWeb/src/ui/MissingReceiptsAdmin/MissingReceiptsAdmin.js
 *
 * This module's only remaining job is books-specific: pull in booksMenu (as
 * before) and supply the books-flavored `MissingReceiptsAdminService`, which
 * hits this product's existing /books/missingReceiptsAdmin/ svc handler
 * (MissingReceiptsAdminController.cs in CSMBooks). CSMAdmin registers its own
 * `MissingReceiptsAdminService` backed by AdminSvc instead — the svc handlers
 * stay separate per host app even though the client UI is shared.
 *
 * The module name, the <missing-receipts-admin> element used in this
 * product's index.aspx, and the ng-app="csm.books.missingReceiptsAdmin"
 * bootstrap in App.ascx are all unchanged by this move.
 *******************************************************************************/
export default angular
  .module('csm.books.missingReceiptsAdmin', [CSMCommonWeb, booksMenu])
  .provider('MissingReceiptsAdminService', MissingReceiptsAdminProvider).name;
